import React, { useEffect, useRef, useState } from 'react';
import { playSound } from '../shared/audio/audio';

const SUPERCONTA_BODY = '/assets/images/superconta-body.svg';
const SUPERCONTA_CAPE_MASK = '/assets/images/superconta-cape-mask.png';
const SUPERCONTA_OPEN_SOUND = '/assets/audio/robot.wav';

export const SHOW_SUPERCONTA_MASCOT_EVENT = 'profase:show-superconta-mascot';

export function showSuperContaMascot(): void {
  window.dispatchEvent(new CustomEvent(SHOW_SUPERCONTA_MASCOT_EVENT));
}

export default function SuperContaMascot() {
  const [visible, setVisible] = useState(false);
  const visibleRef = useRef(false);
  visibleRef.current = visible;

  useEffect(() => {
    const onShow = () => {
      if (visibleRef.current) return;
      playSound(SUPERCONTA_OPEN_SOUND);
      setVisible(true);
    };
    window.addEventListener(SHOW_SUPERCONTA_MASCOT_EVENT, onShow);
    return () => window.removeEventListener(SHOW_SUPERCONTA_MASCOT_EVENT, onShow);
  }, []);

  if (!visible) return null;

  return (
    <div className="crm-superconta-mascot" data-testid="superconta-mascot" aria-hidden="true">
      <div className="crm-superconta-mascot-stage">
        <img src={SUPERCONTA_BODY} alt="" className="crm-superconta-mascot-trail" />
        <img src={SUPERCONTA_BODY} alt="" className="crm-superconta-mascot-body" />
        <div
          className="crm-superconta-mascot-cape"
          style={{
            backgroundImage: `url(${SUPERCONTA_BODY})`,
            WebkitMaskImage: `url(${SUPERCONTA_CAPE_MASK})`,
            maskImage: `url(${SUPERCONTA_CAPE_MASK})`,
          }}
        />
      </div>
    </div>
  );
}
